var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletterA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8132 81.9148V175.305L210.473 134.615L139.503 21.9048L62.8132 81.9148Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.503 21.9048L148.903 18.2549C173.433 56.3549 197.953 94.4249 222.483 132.515C218.483 133.225 214.473 133.905 210.493 134.615L139.503 21.9048Z",
    fill: "#29A063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9534 21.9048L190.243 61.8749V217.505L80.9534 176.255V21.9048Z",
    fill: "#B2E8C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9534 21.9048V176.255L190.243 217.505V61.8749L80.9534 21.9048ZM176.873 140.385L91.5734 108.055V95.6449C120.003 106.375 148.423 117.125 176.873 127.875V140.385ZM177.793 122.125L92.4833 89.7948V77.3949C120.933 88.1349 149.363 98.8649 177.793 109.615V122.125ZM177.793 104.575L92.4833 72.2449V59.8348C120.933 70.5848 149.363 81.3148 177.793 92.0548V104.575Z",
    fill: "#29A063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.373 233.215C159.843 213.915 111.323 194.595 62.7932 175.305L210.453 134.615C209.763 167.485 209.083 200.345 208.373 233.215Z",
    fill: "#72D09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M208.373 233.215L219.873 228.005L222.463 132.515L210.473 134.615L208.373 233.215Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8132 81.9146L208.373 233.215L62.8132 175.305V81.9146Z",
    fill: "#B2E8C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1534 149.975C110.053 173.995 109.953 200.025 95.9234 208.115C94.9634 208.665 90.6134 211.205 89.6334 211.765C76.7034 219.215 58.2835 201.635 45.3335 179.255C32.4135 156.925 28.3334 134.425 39.5434 124.635C39.7634 124.445 42.2834 123.115 42.5134 122.925C43.1734 122.405 44.8334 121.535 45.5734 121.115C59.6134 113.025 82.2534 125.945 96.1634 149.975H96.1534Z",
    fill: "#72D09A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4133 212.685C102.433 204.595 102.543 178.535 88.6532 154.475C74.7632 130.425 52.1433 117.485 38.1233 125.585C24.1033 133.675 23.9933 159.735 37.8833 183.795C51.7633 207.845 74.3933 220.785 88.4133 212.685Z",
    fill: "#B2E8C5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8633 186.875L62.8433 168.395V131.485C71.0833 136.875 79.1133 145.265 85.4033 155.815C91.6733 166.345 95.1633 177.265 95.8633 186.875Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterA);
export default __webpack_public_path__ + "static/media/newsletterA.26828bdfe2710bad8726cfbd95a0a7e2.svg";
export { ForwardRef as ReactComponent };